import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import { HelpersService } from '../../../services/helpers.service';
import { PartnerService } from '../../../services/partner.service';

@Component({
  selector: 'app-help-request',
  templateUrl: './help-request.component.html',
  styleUrls: ['./help-request.component.scss'],
})
export class HelpRequestComponent implements OnInit {
  public showForm: boolean = false;
  public busy: boolean = false;
  public storeName: string = '';
  public emailAddress: string = '';
  public message: string = '';
  public showSentMessage: boolean = false;
  public partner: any = null;

  constructor(
    private helpersService: HelpersService,
    private partnerService: PartnerService,
  ) {}

  ngOnInit() {
    var partner = this.helpersService.getPartnerData();
    var profile = this.helpersService.getProfileData();

    if (partner === undefined || profile === undefined) {
      (<any>window).Intercom('boot', {
        app_id: 'uv5mfvgw',
      });
      (<any>window).Intercom('update');
    } else {
      (<any>window).Intercom('boot', {
        app_id: 'uv5mfvgw',
        name: profile.Name + ' ' + profile.Surname,
        external_id: profile.ID,
        email: profile.Email,
        phone: profile.PhoneNumber,
        company_name: partner.Name,
        created_at: Math.round(
          new Date(partner.CreatedDate || partner.createdDate).getTime() / 1000,
        ).toString(), // Signup date as a Unix timestamp
      });
      (<any>window).Intercom('update');
    }
  }

  /*openHelp() {
      this.showSentMessage = false;
      this.message = "";
      this.partner = this.helpersService.getPartnerData();
      var profile = this.helpersService.getProfileData();
      if (this.storeName === "" && this.partner && this.partner.Name) {
        this.storeName = this.partner.Name;
      }
      if (this.emailAddress === "" && profile && profile.Email) {
        this.emailAddress = profile.Email;
      }
      this.showForm = true;
    }

    valid() {
      return this.emailAddress.length > 0 && this.emailAddress.indexOf("@") > -1 && this.message.length > 0
    }

    sendMessage() {
      var data = {
        url: window.location.href,
        storeName: this.storeName,
        emailAddress: this.emailAddress,
        message: this.message,
        userAgent: navigator.userAgent,
        vendor: navigator.vendor,
        resolution: screen.width + ' * ' + screen.height,
        country: this.partner.Country
      };
      if (this.partner && this.partner.StatusID) {
        var status = this.partner.StatusID === 50 ? 'Active' : this.partner.StatusID === 1 ? 'Trial In Progress - Ends ' + moment(this.partner.TrialEnds).format("YYYY-MM-DD") : this.partner.StatusID === 2 ? 'Trial Expired' : this.partner.StatusID === 3 ? "Payment Missed" : this.partner.StatusID === 4 ? "Payment Method Expired" : this.partner.StatusID === 20 ? "Cancellation In Progress" : this.partner.StatusID === 21 ? "Cancelled" : "N/A";
        data = { ...data, ...{ status: status } }
      }

      this.busy = true;
      this.partnerService.submitHelpRequest(data).subscribe(res => {
        this.busy = false;
        this.showSentMessage = true;
        setTimeout(() => {
          this.showForm = false;
        }, 5000);
      }, err => {
        this.busy = false;
      });

    }*/
}
